import React from "react";

export default function TableSkeleton({ rows = 8 }: { rows?: number }) {
  return (
    <div className="w-full border border-gray-100 rounded-xl bg-white overflow-hidden animate-pulse">
      {/* Skeleton Header */}
      <div className="bg-gray-50 h-12 border-b border-gray-100 flex items-center px-6 gap-4">
        <div className="h-4 w-4 bg-gray-200 rounded" />
        <div className="h-4 w-1/4 bg-gray-200 rounded" />
        <div className="h-4 w-1/6 bg-gray-200 rounded" />
        <div className="h-4 w-1/6 bg-gray-200 rounded" />
      </div>

      {/* Skeleton Rows */}
      <div className="divide-y divide-gray-50">
        {Array.from({ length: rows }).map((_, i) => (
          <div key={i} className="h-16 flex items-center px-6 gap-4">
            <div className="h-4 w-4 bg-gray-100 rounded" />
            <div className="h-4 w-1/3 bg-gray-100 rounded" />
            <div className="h-4 w-1/4 bg-gray-100 rounded" />
            <div className="h-4 w-1/12 bg-gray-100 rounded ml-auto" />
          </div>
        ))}
      </div>
    </div>
  );
}
